<template>
  <Container type="card-full">
    <div>
      <div class="view-container">
        <div class="view-box">
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目编号</div>
              <div class="view-value">{{ project.projectcode }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">平台编号</div>
              <div class="view-value">{{ project.projectno }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">项目名称</div>
              <div class="view-content">{{ project.projectname }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">预计开始时间</div>
              <div class="view-value">{{ project.prsbjbegtime | longDate }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">预计截止时间</div>
              <div class="view-value">{{ project.prsbjendtime | longDate }}</div>
            </div>
          </div>
          <div class="view-row">
            <div class="view-field">
              <div class="view-label">实际开始时间</div>
              <div class="view-value">{{ project.projectjkactualbegtime | longDate }}</div>
            </div>
            <div class="view-field">
              <div class="view-label">实际截止时间</div>
              <div class="view-value">{{ project.projectjkactualendtime | longDate }}</div>
            </div>
          </div>
          <!-- 项目详情 -->
          <div class="split-line"></div>
          <div class="projectAppend">
            <div class="p-append">
              <div class="p-append-h">
                <div class="p-append-h-item">
                  供应商名称
                </div>
                <div class="p-append-h-item">
                  投标文件
                </div>
              </div>
              <div class="p-append-b">
                <div class="p-append-b-item" v-for="item in appendList" :key="item.psuid">
                  <div class="item name">
                    {{ item.comfullname }}
                  </div>
                  <!-- <div class="item-appendinfo el-n">
                                {{item.appendfilename | toolongOmitted}}
                            </div> -->
                  <div class="item-appendinfo el-n">
                    <div class="view-field">
                      <div v-if="item.appendurl" class="view-filelist">
                        <div class="view-fileitem">
                          <div class="view-filename" @click="downFile(item.appendurl)">
                            <a :src="uploadAddr + item.appendurl">{{ item.appendfilename | toolongOmitted }}</a>
                          </div>
                        </div>
                      </div>
                      <div v-else class="view-value">无</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <!-- 竞价附件——供应商只能看自己的 -->
          <div class="split-line"></div>
          <!-- 报价一览表 -->
          <div class="b-KBS">
            <div class="b-header">
              <div class="header-item">序号</div>
              <div class="header-item">投标人名称</div>
              <div class="header-item">投标报价（人民币/元）</div>
              <div class="header-item">投标人代表签名</div>
            </div>
            <div class="b-body-box">
              <div class="b-body" v-for="(item, index) in this.psuList" :key="item.psuid">
                <div class="body-item">{{ index + 1 }}</div>
                <div class="body-item">{{ item.comfullname }}</div>
                <div class="body-item">
                  <span v-if="item.psuamt">￥{{ item.psuamt | qfwVal }}(
                    <amount :money="String(item.psuamt)" v-if="item.psuamt" />)
                  </span>
                </div>
                <div class="body-item" style="color:red;">
                  <!-- <div v-if="+item.psuamtcommituserid !== +item.psuuserid">系统自动确认</div> -->
                  {{ item.psuname }}
                  <!-- </div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </Container>
</template>

<script>
import request from '@/utils/request'
import utils from '../../assets/js/utils'
import common from '@/mixin/common'
import dayjs from 'dayjs'
import amount from '../common/amount'
export default {
  name: "biddingView",
  mixins: [common],
  data() {
    return {
      project: this.$route.params.project,
      appendList: [],
      psuList: []
    }
  },
  created() {
  },
  mounted() {
  },
  async activated() {
    this.init()
    this.getModel()
    this.getAppend()
    this.getBMList()
  },
  filters: {
    longDate(value) {
      return value ? dayjs(value).format('YYYY-MM-DD HH:mm:ss') : ''
    },
    qfwVal(value) {
      if (!!value && +value > 0) {
        return utils.comdify(value)
      } else {
        return value
      }
    },
    toolongOmitted(val) {
      if (val) {
        if (val.length > 20) {
          return val.substring(0, 10) + '...' + val.substring(val.length - 4)
        }
        else {
          return val
        }
      }
    }
  },
  computed: {
    uploadAddr() {
      return this.$store.getters.uploadAddr
    }
  },
  components: { amount },
  methods: {
    init() {
      this.project = this.$route.params.project
      this.appendList = []
      this.psuList = []
    },
    async getModel() {
      let res = await request({
        method: 'get',
        url: '/xmgl/project/findProjectById',
        params: { projectid: this.project.projectid }
      })
      this.project = res
    },
    async getAppend() {
      let res = await request({
        url: '/xmgl/pbr/checkJjPlan',
        method: "get",
        params: { projectid: this.project.projectid }
      })

      if (+this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.comid === +this.$store.getters.loginUser.comid
        })
      }

      this.appendList = res
    },
    async getBMList() {
      let res = await request({
        method: 'get',
        url: '/xmgl/bidOpening/getBMList',
        params: { projectid: this.project.projectid }
      })

      if (+this.project.projectpricelistflag === 0 && +this.$store.getters.loginUser.comtype === 3) {
        res = res.filter(e => {
          return +e.psucomid === +this.$store.getters.loginUser.comid
        })
      }

      if (this.project.projectjkactualendtime != null && +this.project.projecttenderbidmode === 2) {//项目结束后，线下开标的不显示没有报价的
        res = res.filter(e => {
          return e.psuamt != ''
        })
      }
      this.psuList = res
    }
  }
}
</script>

<style lang="scss" scoped>
.view-filename {
  color: #409EFF;
  cursor: pointer;
  flex: 1;
}

.view-container {
  font-size: 14px;
  color: #606266;
  font-family: -apple-system, BlinkMacSystemFont, Segoe UI, PingFang SC, Hiragino Sans GB, Microsoft YaHei, Helvetica Neue, Helvetica, Arial, sans-serif, Apple Color Emoji, Segoe UI Emoji, Segoe UI Symbol;
}

.p-append-h {
  line-height: 48px;
  background-color: #f8f8f9;
  display: flex;
  justify-content: space-around;
  text-align: center;
  border: 1px solid #e8eaec;
}

.p-append-h-item {
  flex: 1;
}

.p-append-h-item:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b {
  border-left: 1px solid #e8eaec;
  border-right: 1px solid #e8eaec;
}

.p-append-b-item {
  display: flex;
  text-align: center;
  border-bottom: 1px solid #e8eaec;
  line-height: 31px;
}

.p-append-b-item div:first-child {
  border-right: 1px solid #e8eaec;
}

.p-append-b-item div {
  flex: 1;
}

.el-n {
  white-space: nowrap;
  /*设置不换行*/
  overflow: hidden;
  /*设置隐藏*/
  text-overflow: ellipsis;
}


.b-KBS {
  border: 1px solid #e8eaec;
  text-align: center;
  background-color: #fff;
  color: #000;
  margin-top: 10px;
}

.b {
  text-align: center;
  border: 1px solid #e8eaec;
}

.b-header {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e8eaec;
}

.header-item:first-child {
  flex: 1;
}

.header-item {
  flex: 3;
  line-height: 40px;
  height: 40px;
  background-color: #F8F8F9;
  border-right: 1px solid #e8eaec;
}

.header-item:last-child {
  border: 0;
}

.b-body-box {}

.b-body {
  display: flex;
  justify-content: center;
  border-bottom: 1px solid #e8eaec;
}

.b-body:last-child {
  border: 0;
}

.body-item:first-child {
  flex: 1;
}

.body-item {
  flex: 3;
  line-height: 40px;
  border-right: 1px solid #e8eaec;

}

.body-item:last-child {
  border: 0;
}

.footer-f {
  /* margin-top: 20px; */
}

.footer-f:first-child {
  margin-top: 20px;
}

.f-o {
  display: flex;
  justify-content: space-around;
  padding: 20px 10px;
  line-height: 40px;
  height: 40px;
  /* border-bottom: 1px solid #e8eaec; */
}

.f-o:first-child {
  /* border-bottom: 1px solid #e8eaec; */
}

.f-o-l {
  flex: 1;
}

.f-o-r {
  flex: 1;
}

.button-box {
  display: flex;
  justify-content: center;
  background-color: #fff;
}

.b-button {
  margin: 20px auto;
  width: 200px;
}
</style>
